import {Component, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular/lazy";
import {ContentService} from "../../services/content.service";
import {Blocks} from "../../structure/enums/blocks.class";
@Component({
    selector: 'app-modal-page',
    templateUrl: './modal-page.component.html',
    styleUrls: ['./modal-page.component.scss'],
    standalone: false
})
export class ModalPageComponent implements OnInit {
    page : any = {
        title : "Loading"
    };
    pageSlug : any;

    constructor(
        public modalCtrl: ModalController,
        public contentService: ContentService,
    ) {}

    async ngOnInit() {
        this.pageSlug = this.pageSlug.replace('/page/','');
        let response: any = await this.contentService.getPageBySlug(this.pageSlug);
        this.page = response.data;
    }

    dismiss() {
        return this.modalCtrl.dismiss({refresh: true}, 'cancel');
    }

    protected readonly Blocks = Blocks;
}
